
import { BrandMetricsCard } from './BrandMetricsCard';
import { SustainabilityChart } from './SustainabilityChart';
import { CarbonFootprintChart } from './CarbonFootprintChart';
import { Building, Package, CheckCircle, Leaf, Award, TrendingDown, Beaker, Shield, BarChart3 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export const BrandDashboard = () => {
  return (
    <div className="space-y-8">
      {/* Benchmark Link */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold">Dashboard Overview</h2>
          <p className="text-muted-foreground">Track your sustainability metrics and certification progress</p>
        </div>
        <Link to="/brand-user/benchmarks">
          <Button variant="outline" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            View Benchmarks
          </Button>
        </Link>
      </div>

      {/* Key Metrics Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <BrandMetricsCard
          title="Total Brands"
          value={8}
          change={12.5}
          changeLabel="vs last quarter"
          trend="up"
          icon={<Building className="h-4 w-4 text-muted-foreground" />}
        />
        <BrandMetricsCard
          title="Total Products"
          value={324}
          change={8.2}
          changeLabel="vs last quarter"
          trend="up"
          icon={<Package className="h-4 w-4 text-muted-foreground" />}
        />
        <BrandMetricsCard
          title="Certified Products"
          value={156}
          change={15.3}
          changeLabel="vs last quarter"
          trend="up"
          icon={<CheckCircle className="h-4 w-4 text-muted-foreground" />}
        />
        <BrandMetricsCard
          title="Certification Rate"
          value="48.1%"
          change={4.7}
          changeLabel="vs last quarter"
          trend="up"
          icon={<Award className="h-4 w-4 text-muted-foreground" />}
        />
      </div>

      {/* Sustainability Metrics Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <BrandMetricsCard
          title="Carbon Reduction"
          value="18.3%"
          change={3.2}
          changeLabel="vs baseline"
          trend="up"
          icon={<TrendingDown className="h-4 w-4 text-green-600" />}
        />
        <BrandMetricsCard
          title="Ingredients in Use"
          value="2,847"
          change={-5.2}
          changeLabel="vs last quarter"
          trend="down"
          icon={<Beaker className="h-4 w-4 text-blue-600" />}
        />
        <BrandMetricsCard
          title="Safer Ingredients"
          value="67.3%"
          change={8.9}
          changeLabel="vs last quarter"
          trend="up"
          icon={<Shield className="h-4 w-4 text-green-600" />}
        />
        <BrandMetricsCard
          title="Green Score"
          value="4.2/5"
          change={0.3}
          changeLabel="vs last quarter"
          trend="up"
          icon={<Leaf className="h-4 w-4 text-green-600" />}
        />
      </div>

      {/* Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SustainabilityChart />
        <CarbonFootprintChart />
      </div>

      {/* Impact Summary */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <BrandMetricsCard
          title="CO₂ Saved (Tons)"
          value="1,247"
          change={22.4}
          changeLabel="vs last year"
          trend="up"
          icon={<Leaf className="h-4 w-4 text-green-600" />}
        />
        <BrandMetricsCard
          title="Ingredients Reformulated"
          value="432"
          change={28.3}
          changeLabel="vs last year"
          trend="up"
          icon={<Beaker className="h-4 w-4 text-blue-600" />}
        />
        <BrandMetricsCard
          title="Cost Savings"
          value="$287K"
          change={14.2}
          changeLabel="vs last year"
          trend="up"
          icon={<TrendingDown className="h-4 w-4 text-green-600" />}
        />
      </div>
    </div>
  );
};
